import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxUserPicker', [
  '$filter',
  '$rootScope',
  'resourceFactorySvc',
  '$q',
  'dataCache',
  function($filter, $rootScope, resourceFactorySvc, $q, dataCache) {
    return {
      restrict: 'E',
      replace: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{placeholder || ' '}}"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          add-on-blur="false"
          class="bootstrap userpicker">
          <auto-complete
            source="getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      scope: { placeholder: '@?' },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.keyProperty = attrs.keyProperty || 'id';

        $scope.selected = [];
        $scope.options = [];
        $scope.tmpValue = null;

        dataCache.ready().then(function() {
          $scope.options = dataCache
            .getArray('user')
            .filter(x => x.isActive || !x.hidden)
            .map(u => ({
              id: u.userID,
              name: `${u.firstName} ${u.lastName}`,
              text: (u.isActive ? '' : '⚠ ') + `${u.firstName} ${u.lastName}`,
              isActive: u.isActive,
            }))
            .sort(dynamicSort('name'));
        });
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el[$scope.keyProperty] === code;
          });
        };

        $scope.getSuggestions = function(search) {
          return $filter('filter')($scope.options, search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue($scope.selected.map(x => x[$scope.keyProperty]));
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            $scope.selected = value.map(x => findOption(x));
          }
        };
      },
    };
  },
]);
